// Оценка с 5 звезди + коментар: наемодател↔наемател (след приключило
// отношение) или наемодател→майстор (след платена работа).

import React, { useState } from 'react';
import { Pressable, Text, View } from 'react-native';
import { api } from '../api';
import { showError, showSuccess } from '../toast';
import { Button, Card, COLORS, Input, Label, Muted, Screen, Title } from '../ui';
import { t } from '../i18n';

export default function ReviewScreen({ route, navigation }: any) {
  // tenancyId (наемно отношение) ИЛИ offerId (платена работа на майстор)
  // ИЛИ jobRequestId (директна работа при доверен майстор)
  const { tenancyId, offerId, jobRequestId, targetName } = route.params;
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    setLoading(true);
    try {
      if (offerId) {
        await api('/reviews/handyman', { body: { offerId, rating, comment: comment || undefined } });
      } else if (jobRequestId) {
        await api('/reviews/handyman', { body: { jobRequestId, rating, comment: comment || undefined } });
      } else {
        await api('/reviews', { body: { tenancyId, rating, comment: comment || undefined } });
      }
      showSuccess(t('Благодарим! Ревюто е записано.'));
      navigation.goBack();
    } catch (e: any) {
      showError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Screen>
      <Title>{t('Оценка')}</Title>
      <Card>
        <Muted>{t('Оценявате: {name}', { name: targetName })}</Muted>
        <Label>{t('Колко звезди?')}</Label>
        <View style={{ flexDirection: 'row', gap: 6, marginVertical: 8 }}>
          {[1, 2, 3, 4, 5].map((star) => (
            <Pressable key={star} onPress={() => setRating(star)}>
              <Text style={{ fontSize: 38, color: star <= rating ? '#F59E0B' : COLORS.border }}>★</Text>
            </Pressable>
          ))}
        </View>
        <Label>{t('Коментар (по избор)')}</Label>
        <Input
          value={comment}
          onChangeText={setComment}
          multiline
          placeholder={t('Разкажете накратко за опита си…')}
          style={{ minHeight: 80, textAlignVertical: 'top' }}
        />
        <Button title={t('Запази оценката')} onPress={submit} disabled={rating === 0} loading={loading} />
      </Card>
    </Screen>
  );
}
